import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { bindActionCreators } from 'redux'

import { useToast } from '@chakra-ui/react'

import { setDsrPages, updatePdsr, resetUpdatePdsrOutcome } from '../../actions/dsr-actions'
import LaunchdeckButton from '../../../global/components/helper-components/components/LaunchdeckButton'
import { triggerLaunchdeckToast } from '../../../global/helpers/global-helpers'
import { removeEmptySubWidgets, removeEmptyWidgets } from '../../helpers/dsr-draft-helpers'


function SaveDraftProspectDsrButton({ pDsrId, dsrPages,
  //Actions
  updatePdsr,
  setDsrPages,
  resetUpdatePdsrOutcome,
  // Redux
  updateProspectDsrOutcome,
  isMobileView
}) {
  const toast = useToast();
  const [saveButtonUsed, setSaveButtonUsed] = useState(false)

  useEffect(() => {
    if (updateProspectDsrOutcome) {
      const { updatePdsrStatus, updatedPdsrId, sourceEvent } = updateProspectDsrOutcome || {};

      if (sourceEvent === "save-draft-prospect-pdsr") {
        if (updatePdsrStatus === 'success' && updatedPdsrId === pDsrId && pDsrId !== undefined && saveButtonUsed) {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-success-state",
              bannerText: "Prospector Room saved",
              label: "We've also cleared away empty content blocks for your convenience",
              isMobileView
            })
          )

        } else if (!updatePdsrStatus) {
          toast(
            triggerLaunchdeckToast({
              useCase: "show-error-state",
              bannerText: "Error copying link",
              label: "Unfortunately something went wrong. Please try again later.",
              isMobileView
            })
          )
        }

        resetUpdatePdsrOutcome()
        setSaveButtonUsed(false)
      }
    }
  }, [updateProspectDsrOutcome, toast, pDsrId, resetUpdatePdsrOutcome]);

  function handleClick() {
    if (pDsrId && dsrPages) {
      const clearedWidgets = removeEmptySubWidgets(dsrPages);
      const filteredDsrPagesLocalState = removeEmptyWidgets(clearedWidgets);


      updatePdsr({
        pDsrId: pDsrId,
        dsrPages: filteredDsrPagesLocalState,
        sourceEvent: "save-draft-prospect-pdsr"
      })

      setDsrPages(dsrPages)
      setSaveButtonUsed(true)
    }
  }

  return (
    <LaunchdeckButton
      label='Save'
      bg='white'
      color='brandDark.500'
      fontSize='0.8em'
      onClick={() => handleClick()}
    />

  );
}

function mapStateToProps(state) {
  return {
    updateProspectDsrOutcome: state.updateProspectDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePdsr,
      setDsrPages,
      resetUpdatePdsrOutcome
    },
    dispatch,
  )


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SaveDraftProspectDsrButton));
